var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/react-editor';
import styled from 'styled-components';
export function QuillComponent(props) {
    var handleChange = function (newValue) {
        if (props.onChange) {
            props.onChange(newValue);
        }
    };
    var toolbarOptions = [['heading', 'bold', 'italic', 'strike']];
    var ref = React.createRef();
    return (React.createElement(EditorWrapper, { children: React.createElement(Editor, { placeholder: "\uC0C1\uC810 \uC124\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.", onKeyup: function () {
                var _a;
                if (ref.current) {
                    handleChange((_a = ref.current) === null || _a === void 0 ? void 0 : _a.getInstance().getHTML());
                }
            }, ref: ref, toolbarItems: toolbarOptions, hideModeSwitch: true, usageStatistics: false, initialEditType: "wysiwyg", initialValue: props.value }) }));
}
var EditorWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .toastui-editor-defaultUI-toolbar {\n    background-color: white;\n  }\n\n  & .toastui-editor-main {\n    z-index: 0 !important;\n  }\n"], ["\n  & .toastui-editor-defaultUI-toolbar {\n    background-color: white;\n  }\n\n  & .toastui-editor-main {\n    z-index: 0 !important;\n  }\n"])));
var templateObject_1;
